import CatSubGradeDropdown from '@/components/cat-sub-grade-drpdn/cat-sub-grade-drpdn';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'signature-contents-publishers',
    components: {
        'material-icons': GoogleMaterialIcon,
        'cat-sub-grade-drpdn': CatSubGradeDropdown,
    },
})

export default class SignatureContentsPublishers extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    @Prop()
    private categorySubjectData: any;

    private updateValue: any;

    private isWithGrades: any = false;

    private isWithFw: any = false;

    private subSetting: boolean = false;

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private dataStringValue: any = '';

    private content: any = {};

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }
    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (this.isReadOnly) {
            this.dataPropsValues = this.content;
            // this.fetchDisplayProp();
        }
    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private updateCatSub(value: any) {
        this.updateValue = value;
        this.onUpdate();
    }

    private updateScore(value: any) {
        this.subSetting = value;
        this.onUpdate();
    }

    private onUpdate() {
        if (!this.isWithGrades && !this.isWithFw) {
            if (!this.isWithGrades && !this.isWithFw) {
                if (this.updateValue && this.updateValue.subjects && this.updateValue.subjects.selectedItems) {
                    this.$emit('input', { [this.updateValue.subjects.selectedItems]: this.subSetting });
                }
            }
        }
    }


    private async fetchDisplayPropParent() {
        const categoryList = this.categorySubjectData;
        // const valueData: any = { "CCSS.K12.MA": true, "TNM.K12.MA": false, "SC.HE.CS":true, "GDF.HE.BS":false };
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];
        for (const prop in valueData) {
            if (valueData.hasOwnProperty(prop)) {
                const propSplit = prop.split('.');
                const data: any = {
                    keyName: prop,
                    keyValue: valueData[prop],
                    categoryId: propSplit[1],
                    subjectId: `${propSplit[1]}.${propSplit[2]}`,
                    frameworkId: propSplit[0],
                };
                dataValuesCalculate.push(data);
            }
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private makeStringToShow() {
        const dataValue = this.dataPropsValues;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} | ${iterator.frameworkId} = ${iterator.keyValue}; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

}
